export default {
  header: {
    menu: {
      home: "Home Page",
      product: "Product Services",
      tool: "Air Transport Tools",
      sales: "HOT",
      about: "About US",
      my: "My Account",
      airportCode: "Airport Code",
      hs: "HS Code",
      tact: "TACT Enquiry",
      airlineInfo: "Flight Information",
      planeType: "Aircraft Type",
      track: "Cargo Tracking",
      login: "Sign in",
      register: 'Sign up',
      logout: "Sign out",
    },
    searchbar: {
      volume: "Volume",
      type: "Type of Goods",
      airline: "Airline",
      weight: "Gross Weight",
      c_weight: "Chargeable Weight",
      proportion: "Proportion",
      tip1:
        "Enter the port of destination to filter;Enter gross weight and volume to calculate the total price"
    }
  },
  footer: {
    why: "Selection Reasons",
    reason1: "Our one-stop air transport service capacity",
    reason2:
      "Our air transport scheme, transport capacity and price and output capability",
    reason3:
      "Electronic air transport, mobile booking and  management capacity",
    reason4: "Air cargo track tracking capability",
    reason5:
      "Our professional air transport execution and  capability of our service team",
    sales: "HOT",
    intro: "Introduction to Yctop",
    copyright:'All rights reserved   Copyright and trademark notice',
    copyright2:'Guangdong ICP No. 19009312-1',
  },
  side: {
    service: "Online Customer Service",
    Hotline: "Hotline",
    mobile: "Mobile Yctop",
    all: "National Customer Service Phone",
    every: "Service Telephones in All Regions",
    north: "North China",
    east: "East China ",
    south: "South China",
    weapp: "WeChat Mini Program",
    public: "Wechat Official Account",
    search: "WeChat Search “ZhiJianHuoYun”"
  },
  home: {
    plate: "Delivery Plate",
    title: "One-stop International Air Transport Logistics Service",
    subtitle: '',//"Investment Enterprise with Venture Capital",
    International: "International Air Freight",
    book: "Search",
    departure: "Port of Departure",
    destination: "Port of Destination",
    transport: {
      title: "Integrated International Logistics Transport Programme",
      subtitle:
        "Matching national airline solutions.  Sharing global cross-border logistics resources",
      p1: "Intelligent Booking",
      span1:
        "Intelligent search engine for real-time price check, recommended routes, online order, and  manual answer.",
      p2: "Trailer Traffic",
      span2:
        "Cooperative fleet covers key ports;  National transfer  ensure cost control.",
      p3: "Customs Clearance Services",
      span3:
        "National professional customs clearance team; The cost is calculated by bull so that it is open and clear.",
      p4: "Storage and packaging",
      span4:
        "Security integrated services including flexible storage,  disassembly label,  weight dimensions and  photo taken in and out.",
      p5: "Overseas Port to Gate",
      span5:
        "Huge overseas agency network,  overseas customs clearance, DDU., DDP, door delivery and other one -stop service.",
      p6: "Insurance Claims",
      span6:
        "Ultra low rate,  system integrating,  real-time issuing, special assistance."
    },
    reliable: {
      title: "Reliable Air Freight Plan  Real-time Quotation Enquiry Service",
      p:
        "Intelligent sorting based on full-dimensional rich industry data business experience, by virtue of advanced algorithms, and combined with air transport experts to recommend national quality routes.Opening up upstream and downstream communication channels with formatted inquiry request and intelligent quotation scheme.",
      btn: "Inquiry booking"
    },
    booking: {
      title: 'Book a "cargo hold" like booking ticket',
      p:
        "The platform has abundant transport capacity with transparent price, real-time quotations via computer or mobile phone, online one-click booking and order management operations."
    },
    check: {
      title: 'Check "where is the cargo going" like checking out Express',
      p:
        'The system automatically pushes QR code of each cargo "electronic identity", and users can query logistics track in real time.'
    },
    team: {
      title: "Professional Customer Service Team",
      p:
        "24-hour online customer service cargo controls the freight program, provides logistics advice, assists the safety of goods in the whole process, with timely arrival at the destination.",
      btn: "Booking of air transport specialists"
    },
    contacts: {
      title: "Regional Contacts",
      north: "North China Region",
      northPerson: "Mr. Zhao",
      northAddress:
        "Hongyuan Hangcheng Plaza, Nanfa Xinzhen, Shunyi District, Beijing",
      east: "East China Region",
      eastPerson: "Mr. Ding",
      eastAddress:
        "Unit 503, Block A, Shanghai Digital Science Park, Pudong New Area, Shanghai",
      south: "South China Region",
      southPerson: "Mr. Feng",
      southAddress:
        "Room 1308, Guangzhou International Electronic Building, Yuexiu District, Guangzhou"
    },
    tips: {
      p1: "Yctop.com special launch",
      p2: "User reward questionnaire survey",
      p3: "The top 100 participating member users",
      p4: "Get It Now",
      p5: "100 yuan Jingdong card",
      p6: "Benefits are first come first served!",
      p7: "Enter Now",
      p8: "Your opinion is our motivation for continuous improvement!"
    }
  },
  query: {
    cabin: "Cabin",
    info: "Flight Information",
    book: "Booking",
    all: "All",
    detail: "Product Details",
    route: "Transportation Route",
    time: "Transit Time",
    date: "Flight Date",
    datelimt: "Flight Validity",
    otherIntro: "Other Instructions",
    similarProduct: "Similar Products",
    basic: "Basic Information",
    calculation: "Calculation",
    oneServe: "One-stop Service",
    currency: "Currency",
    estimate: "Estimated Cost",
    declaration: "Domestic Declaration",
    delivery: "Domestic Delivery",
    overseas: "Overseas Service",
    declarationpalce: "Customs Declaration Place",
    deliveryplace: "Pickup Place",
    handinplace: "Delivery Place",
    overseasplace: "Served Place",
    choose: "Please Choose",
    selected: "Domestic customs declaration has been selected, estimated cost",
    cny: "CNY",
    singleAsk: "Single Quiry",
    possiblecost: "Possible Costs",
    costCalculation: "Cost Calculation",
    airfreight: "Air Freight",
    airfreightAdd: "Air Freight Surcharge",
    customsfee: "Domestic Customs Declaration Fee",
    deliveryfee: "Domestic Delivery Fee",
    overseasfee: "Overseas Service Fee",
    total: "Total",
    rate: "Exchange Rate",
    details: "Details",
    inquiry: "Inquiry Now",
    booknow: "Book Now",
    login: "Sign in Immediately",
    start: "About to Start",
    being: "Is Snapping up",
    end: "Activity Ends",
    word:
      "After the actual booking, the cost may increase or decrease according to the actual situation",
    tips: "Tips",
    tips1:
      "Due to the recent shortage of airline space, online prices are for reference only (except for limited-time special offers).",
    tips2: "If you have ",
    yips3: "a specific shipping time",
    tips4: "please contact customer service ",
    tips5:
      "to confirm the shipping space and more accurate prices. Please understand!",
    exchange: "Converted to CNY",
    area: "Area",
    expensedesc: "Expense Description",
    whether: "Whether to Divide",
    singlelimit: "Single Piece Weight Limit",
    miniweight: "Minimum Carrying Weight",
    transitInformation: "Transit Information",
    otherdesc: "Other Instructions",
    sold: "Space sold",
    begin: "Begin",
    soldOut: "Sold Out",
    moreList: "More Recommended Airlines",
    surplus:'Surplus',
  },
  tool: {
    query: "Enquiry",
    exp: "Example",
    querytitle: "Condition Query",
    airlinesCode: "Airline Code",
    zh: "Chinese Name",
    toThreeCode: "Don't know the airport code? Click here to search",
    level: "Level",
    Freightrate: "Freight Rate",
    aircraftType: "Type Of Aircraft",
    model: "Model",
    tariffInfo: "Tariff Information",
    condition: "Monitoring Condition",
    elements: "Declaration Elements",
    track: {
      title: "International air cargo one-stop track query",
      waybillNum: "Air Waybill Number",
      basicInfo: "Basic Cargo Information",
      transit: "Transit Port",
      pieces: "Packages",
      trackInfo: "Track Summary Information",
      noBasic: "No basic cargo information!",
      noTrack: "No cargo track information temporarily!",
      customs: "Customs",
      detail: "View Track Details",
      leave: "Leave The Port",
      Pickup: "Pick Up",
      manifest: "Manifest",
      clearance: "Clearance",
      follow: "Follow the WeChat Mini Program to view the track details."
    }
  },
  order:{
    startDate:'Start Date'
  },
  user:{
    nickname:'Username',
    email:'Email address',
    pw:"Password",
    confirm:'Confirm password ',
    company:'Company name',
    spread:'Promotion code',
    exist:'Existing account?',
    welcome:'Welcome to join yctop',
    title:'Creat your account',
    new:'New to yctop? '
  },
  notfound: {
    p: "Sorry, the page you were looking for was not found...",
    back: "Back to Homepage",
    m: "Second",
    no_p1:'Sorry, there is no relevant content.',
    no_p2:'If you need more services, you can call the customer service number:',
    no_p3:'Or click the online customer service button to consult customer service staff online.',
    no_p4:'Online Service'
  },
  compatibility:{
    p1:'Browser Compatibility List',
    p2:'Google Chrome',
    p3:'has the best compatibility',
    p4:'Opera browser, Firefox browser, Safari browser (Mac) have better compatibility',
    p5:'360 browser speed mode, QQ browser speed mode, Sogou browser high speed mode, cheetah browser, travel browser compatibility is better',
    p6:'UC browser, Baidu browser, IE browser',
    p7:'Browser compatibility improvement settings',
    p8:'Set the compatibility mode of 360 browser, QQ browser, and Sogou browser to extreme speed mode to better browse this website. The specific setting steps are as follows:',
    p9:'You can switch between extreme speed mode and compatibility mode by yourself. There is an icon behind the website at the top of the browser.',
    p10:'Click the icon below and a selection dialog box will appear, as shown in the figure, and then click to switch to the speed mode.',
  }
};
